var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aTarget{fill:#b30200;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aTarget",
    d: "M11,1V2.049A10,10,0,0,0,2.049,11H1v2H2.049A10,10,0,0,0,11,21.951V23h2V21.951A10,10,0,0,0,21.951,13H23V11H21.951A10,10,0,0,0,13,2.049V1Zm0,3.068V6h2V4.068A8.01,8.01,0,0,1,19.932,11H18v2h1.932A8.01,8.01,0,0,1,13,19.932V18H11v1.932A8.01,8.01,0,0,1,4.068,13H6V11H4.068A8.01,8.01,0,0,1,11,4.068Z",
    transform: "translate(-1 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.a355ca1eb4be5d6ec0413ef6a98472ef.svg";
export { ForwardRef as ReactComponent };